export default __webpack_public_path__ + "static/button-alignment-page-dark-41d2bb30bb26fa79ff71b67f796c7c4b28b7f046b1c21daa87a9faf5eac1ea0e.png";